export const reducerTrailsTypes = {
  GET_CALL_TEMPLATES: "reducer/GET_CALL_TEMPLATES",
  GET_CITIES_WITH_REGIONS: "reducer/GET_CITIES_WITH_REGIONS",
  GET_CONTRACT_STATUSES: "reducer/GET_CONTRACT_STATUSES",
  GET_FORMS: "reducer/GET_FORMS",
  GET_PLANNING_PEOPLE: "reducer/GET_PLANNING_PEOPLE",
  GET_ALL_PLANNING_PEOPLE: "reducer/GET_ALL_PLANNING_PEOPLE",
  GET_PRESENTATION_TIMES: "reducer/GET_PRESENTATION_TIMES",
  GET_PROJECT_CONCENT: "reducer/GET_PROJECT_CONCENT",
  GET_PROJECT_SALES: "reducer/GET_PROJECT_SALES",
  GET_REGIMENTS: "reducer/GET_REGIMENTS",
  GET_REGIONS: "reducer/GET_REGIONS",
  GET_RESERVATION_STATUSES: "reducer/GET_RESERVATION_STATUSES",
  GET_TRAILS: "reducer/GET_TRAILS",
  GET_DEPARTURE: "reducer/GET_DEPARTURE",
  GET_DEPARTURE_DATE: "reducer/GET_DEPARTURE_DATE",
  GET_ALL_DICTIONARY: "reducer/GET_ALL_DICTIONARY",
  GET_ALL_CITIES_WITH_REGIONS: "reducer/GET_ALL_CITIES_WITH_REGIONS",
  GET_ALL_FORMS: "reducer/GET_ALL_FORMS",
  GET_ALL_DEPARTURE: "reducer/GET_ALL_DEPARTURE",
  GET_ALL_DEPARTURE_DATE: "reducer/GET_ALL_DEPARTURE_DATE",
};
